export const columnLayout = (onIncomeButtonClick, popDepartureImage) => {
  const gridColumnLayOut = [
    {
      dataField: "kakaotalkYn",
      headerText: "입차호출",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "입차호출",
        onClick: onIncomeButtonClick,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          // 행 아이템의 name 이 운송상태가 등록으로 되어 있으면  라면 버튼 표시
          if (
            (item.transStatusCd === "A" || item.transStatusCd === "G") &&
            item.tmsOdrNo !== ""
          ) {
            return true;
          }
          return false;
        },
      },
      labelFunction: function (rowIndex, columnIndex, value, headerText, item) {
        if (item.transStatusCd === "G") {
          return "입차취소";
        } else if (item.transStatusCd === "A") {
          return "입차호출";
        }
        return value;
      },
    },
    {
      dataField: "systemCd",
      headerText: "회사구분",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantCd",
      headerText: "사업장구분",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantNm",
      headerText: "사업장",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "transStatusCd",
      headerText: "배차상태",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "transStatusCdNm",
      headerText: "배차상태",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      styleFunction: function (
        rowIndex,
        columnIndex,
        value,
        headerText,
        item,
        dataField
      ) {
        if (item.transStatusCd === "T" || item.transStatusCd === "R") {
          return "my-cell-style1";
        } else if (item.transStatusCd === "D") {
          return "my-cell-style2";
        } else if (item.transStatusCd === "A") {
          return "my-cell-style3";
        } else if (item.transStatusCd === "W") {
          return "my-cell-style4";
        } else if (item.transStatusCd === "S" || item.transStatusCd === "I") {
          return "my-cell-style5";
        }
        return null;
      },
    },
    {
      dataField: "arrvDt",
      headerText: "도착시간",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemCd",
      headerText: "사전등급",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inspRmks",
      headerText: "검수원비고",
      editable: true,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemNm",
      headerText: "사전등급",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inWeight",
      headerText: "입차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outWeight",
      headerText: "출차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "realWeight",
      headerText: "입고중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vndrCd",
      headerText: "공급업체 코드",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vndrNm",
      headerText: "공급업체",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "vhclNo",
      headerText: "차량번호",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vhclNo4",
      headerText: "차량번호4자리",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "drivNm",
      editable: false,
      headerText: "운전자",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "drivTel",
      editable: false,
      headerText: "전화번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "loadAreaAddr",
      headerText: "상차지역",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "blNo",
      editable: false,
      headerText: "B/L",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "shipNm",
      headerText: "모선명",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "portNm",
      headerText: "입항항구",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "scrapAreaCd",
      headerText: "하차지역",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "scrapAreaCdNm",
      headerText: "하차지역",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vhclNo",
      headerText: "차량번호",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inDate",
      headerText: "입차",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outDate",
      headerText: "출차일시",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "tmsOdrSeq",
      headerText: "배차순번",
      editable: false,
      //visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "wghtDt",
      headerText: "입고일자",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
  ];
  return gridColumnLayOut;
};
